export const MAX_VIDEO_DURATION_SEC = 1800; // 30 minutes
